import { fold } from '../dutch.js';
/** Smallest to largest — the order the size toggle renders. */
export const BOX_SIZES = ['klein', 'middel', 'groot'];
/** The full, cumulative list of items in one section at a given box size. */
export function boxItemsForSize(section, size) {
    const items = [...section.base];
    if (size === 'middel' || size === 'groot')
        items.push(...section.middel);
    if (size === 'groot')
        items.push(...section.groot);
    return items;
}
/**
 * A dedupe key that folds Dutch inflection, so "appels" and "appel" collapse and
 * a product listed in two sections (a base line and a box) is counted once. Uses
 * the identity-safe `fold`, applied per word — never a decompounder or a synonym
 * table (see `dutch.ts`).
 */
function dedupeKey(phrase) {
    return phrase.toLowerCase().trim().split(/\s+/).filter(Boolean).map(fold).join(' ');
}
/**
 * Every distinct item in the whole box at a given size, de-duplicated across all
 * its box-type sections, first spelling kept. This is the ingredient list the
 * recipe suggester will be handed.
 */
export function boxIngredients(response, size) {
    const seen = new Set();
    const out = [];
    for (const section of response.sections) {
        for (const item of boxItemsForSize(section, size)) {
            const key = dedupeKey(item);
            if (!key || seen.has(key))
                continue;
            seen.add(key);
            out.push(item);
        }
    }
    return out;
}
//# sourceMappingURL=compose.js.map